import { render, staticRenderFns } from "./DamageInfo.vue?vue&type=template&id=9aad75ea"
import script from "./DamageInfo.vue?vue&type=script&lang=js"
export * from "./DamageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports